import {Select} from '@mantine/core';
import {Box} from 'src/design/atoms/Box';
import type {ComboboxData} from '@mantine/core';
import React from 'react';
import classes from './SidebarFooterSelect.module.css';

export interface SidebarFooterSelectProps {
  label: string;
  data: ComboboxData;
  value: string | null;
  onChange: (value: string | null) => void;
  isLoading?: boolean;
  clearable?: boolean;
  placeholder?: string;
  highlighted?: boolean;
}

/**
 * @registry Sidebar-footer Select (black input, white label) shared by the
 * Instance and Project-scope switchers.
 */
export const SidebarFooterSelect: React.FC<SidebarFooterSelectProps> = ({
  label,
  data,
  value,
  onChange,
  isLoading,
  clearable,
  placeholder,
  highlighted,
}) => {
  return (
    <Box mt="sm">
      <Select
        label={label}
        data={data}
        value={value}
        onChange={onChange}
        disabled={isLoading}
        clearable={clearable}
        placeholder={placeholder}
        classNames={{
          input: highlighted
            ? `${classes.input} ${classes.highlighted}`
            : classes.input,
          label: classes.label,
        }}
      />
    </Box>
  );
};
